<template>
    <LayoutWrapper :id="id">
        <!--<AlgorithmTypeSection />-->
        <!--<NWGapExtentField />-->
        <!--<NWGapOpenField />-->
        <!--<NWScoreMatrixField />-->
        <!--<SequenceTypeField />-->
        <!--<DBTypeField multiple />-->
        <!--<SubjectLengthField />-->
        <!--<MultiSubjectLengthField />-->
        <!--<AlignmentIdentityField />-->
        <!--<QueryIdentityField />-->
        <!--<QueryCoverageField />-->
        <!--<SubjectIdentityField />-->
        <!--<SubjectCoverageField />-->
        <!--<MaxTargetSequenceField />-->
        <!--<MatchWithGapsField />-->
        <!--<EvalueField />-->
        <!--<LowComplexRegionField />-->
        <!--<DefaultAlgorithmSettingField />-->
        <!--<AlgorithmField />-->
        <!--<ScoringMatrixField />-->
        <!--<WordSizeField />-->
        <!--<MatchScoresField />-->
        <!--<GapCostsField />-->
        <!--<ResetSection />-->
        <slot />
    </LayoutWrapper>
</template>

<script>
import snakeCase from 'lodash/snakeCase';
import { SEARCH_TYPE } from './constants';
import * as Widgets from './widgets/index';
import * as Components from './components/index';
import { createStore } from './store';

export default {
    name: 'BioSearchSettingProvider',
    components: {
        ...Components,
        ...Widgets,
    },
    inject: {
        parentStore: {
            from: 'store',
            default: null,
        },
        parentProvider: {
            from: 'provider',
            default: null,
        },
    },
    provide() {
        return {
            provider: this,
            store: this.store,
        };
    },
    props: {
        /**
         * 搜索类型 例如：cdr antibody fragment
         * 这个是SEARCH_TYPE的key
         */
        searchType: {
            type: String,
            default: SEARCH_TYPE.sequence,
        },
        /**
         * 解释里的图片移到这里
         */
        images: {
            type: Object,
            default: () => ({}),
        },
        /**
         * 检索设置对象
         * 对象的引用变动时会根据变动后创建新的绑定对象
         */
        searchSetting: {
            type: Object,
            required: true,
        },
        /**
         * 来自外部的设置项
         * 外部的值会覆盖settingValues
         * settingValues变动也会更新externalSetting，前提是externalSetting是响应式的、可写入的
         */
        externalSetting: {
            type: Object,
            default: () => ({}),
        },
        /**
         * 来自外部的设置项的 names
         */
        externalConfigNames: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            store: createStore(this.$props),
        };
    },
    computed: {
        id() {
            return [
                'bio_setting',
                this.searchType,
            ].map(snakeCase).join('-');
        },
    },
    mounted() {
        if (!this.eventHandler_onReset) {
            this.eventHandler_onReset = () => this.resetSettings();
        }
        if (this.parentProvider) {
            this.parentProvider.$on('reset', this.eventHandler_onReset);
        }
    },
    beforeDestroy() {
        if (this.parentProvider && this.eventHandler_onReset) {
            this.parentProvider.$off('reset', this.eventHandler_onReset);
        }
    },
    methods: {
        resetSettings() {
            this.$emit('reset');
        },
    },
};
</script>
